import '@/lib/typedef';
import { buildQuery } from '@/lib/helper';
import client from '@/lib/http-client';

const endpoint = '/wishlist';

export default {
	getWishlist(cb, errorCb) {
		const url = endpoint;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
	addWishlist(params, cb, errorCb) {
		const url = endpoint;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
	removeWishlist(productId, cb, errorCb) {
		const url = `${endpoint}/${productId}`;
		client.delete(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
	bulkDeleteWishlist(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/bulk_delete?${query}`;
		client.delete(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
};
